export const stripeInputStyles = {
  style: {
    base: {
      color: '#414141',
      fontWeight: 400,
      fontFamily: 'Source Sans Pro, sans-serif',
      fontSize: '16px',
      lineHeight: 1.25,
      fontSmoothing: 'antialiased',
      backgroundColor: '#fff',
      ':-webkit-autofill': {
        color: '#414141',
      },
      '::placeholder': {
        color: '#808080',
      },
    },
    invalid: {
      color: '#414141',
    },
  },
};
